const ComponentsLookup = {
  "default-footer": "DefaultFooter01804719007e44ba85050957a56d3ec9"
}

export default ComponentsLookup;